export const DEFAULT_SUGGESTIONS = [
  // Charts & Dashboard
  "How to create custom Charts from chat?",
  "How to export Charts to the dashboard?",
  "CynthAI Chat: Creating Charts with prompts",
  "Best practice for generating charts",
  "How to customize dashboard widgets",
  "Saving and organizing chart templates",

  // Chat & Prompts
  "How to write an effective prompt?",
  "Charts: customizing axes and labels",
  "Using natural language to query data",
  "Common prompt patterns and examples",
  "Chat history and saving conversations",

  // Document Analysis
  "How to upload and analyze documents",
  "Supported file formats and limitations",
  "Document classification explained",
  "Extracting data from documents",
  "Batch processing multiple documents",

  // Audit & Data Management
  "Getting started with audit management",
  "Trial balance and financial reporting",
  "Data source configuration",
  "Connecting to external data sources",
  "Audit task creation and workflows",

  // Classifications & Organization
  "Understanding classifications",
  "Creating custom classification rules",
  "Data mapping and transformations",
  "Organizing data by classifications",

  // General
  "Account settings and preferences",
  "Collaboration and team management",
  "Data export and sharing options",
  "Keyboard shortcuts and tips",
  "Troubleshooting common issues",
];
